import React, { PropsWithChildren } from 'react'

// types
import { ContextProps } from '../types/types'

// page
import MyReservationsPage from '../pages/MyReservationsPage/MyReservationsPage'
import useZodQueryParams from '../hooks/useZodQueryParams'
import { myReservationsPageQuerySchema } from '../utils/zodQuerySchemas'

const MyReservationsRoute = (props: PropsWithChildren<ContextProps>) => {
	const [query, setQuery] = useZodQueryParams(myReservationsPageQuerySchema)

	return <MyReservationsPage {...props} query={query} setQuery={setQuery} />
}

export default MyReservationsRoute
